import { instance } from './instance'
import { API_URL } from '@/config'

/**
 * Charge-to-Room (Folio Posting) — Admin API.
 *
 * Phase 1: Manueller Tagesexport (CSV → Protel/Opera/Mews per Hand).
 * Phase 2: Direkte PMS-Integration via PmsAdapter.
 */
export const roomChargeService = {
  /**
   * @param {Object} params { status: 'open'|'posted'|'all', date: 'YYYY-MM-DD', room?: string }
   */
  async list(params = {}) {
    const { data } = await instance.get('/room-charges', { params })
    return data
  },

  /**
   * Liefert eine CSV-Datei zum Download.
   * @param {string} date 'YYYY-MM-DD'
   */
  exportCsvUrl(date) {
    const qs = new URLSearchParams({ date }).toString()
    return `${API_URL}/room-charges/export?${qs}`
  },

  async markPosted(orderId, folioReference = null) {
    const { data } = await instance.post(`/room-charges/${orderId}/mark-posted`, {
      folioReference,
    })
    return data
  },

  async markAllPosted(date) {
    const { data } = await instance.post('/room-charges/mark-all-posted', { date })
    return data
  },
}

export default roomChargeService
